var render = function render(){var _vm=this,_c=_vm._self._c;return _c('redness-locations-template',{attrs:{"gender":_vm.gender,"redness-limited-to-pimples":_vm.rednessLimitedToPimples,"redness-locations":_vm.rednessLocations,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }